import * as React from 'react';

import Nav from './components/Nav';
import About from './content/About';
import Boats from './content/Boats';
import Cabins from './content/Cabins';
import Camping from './content/Camping';
import Fishing from './content/Fishing';

import './App.css';


function App() {
    return (
        <div className="app">
            <Nav />
            <main className="content">
                <About />
                <Cabins />
                <Camping />
                <Boats />
                <Fishing />
            </main>
        </div>
    );
}

export default App;
